/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ConfirmModal from "./ConfirmModal";
import ContactForm from "../forms/ContactForm";
import ContactBg from "../assets/images/contact-bgimage.jpg";

const Contact = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='contact'>
      <Container>
        <Row>
          <Col lg='6' md='6' sm='12' className='heading'>
            <h1>Contact Me</h1>
            <ContactForm handleShow={handleShow} />
          </Col>
          <Col lg='6' md='6' sm='12'>
            <div className='google-map my-5 py-5'></div>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        Title='Successfully Done..!'
        message='Your details are sent successfully...'
        show={show}
        handleClose={handleClose}
      />
    </div>
  );
};

export default Contact;
